import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { goUp } from '../../../../common/src/utils/cssAnimationsUtils';
import { mq } from '../../../../common/src/utils/styledComponentsUtils';
import OffersToolbarContainerMobile from '../offers/OffersToolbarContainerMobile';
import Toolbar from '../toolbar/Toolbar';
import { RootState } from '../../store/redux/reducers/rootReducer';
import { setShowInfoModal } from '../../store/redux/slices/productFactorySlice';
import useMobileBreakpoints from '../../../../common/src/hooks/useMobileBreakpoints';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  className?: string;
}

const ViewWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { showInfoModal } = useSelector(
    (state: RootState) => state.productFactory,
  );

  const { isLaptop } = useMobileBreakpoints();

  return (
    <Wrapper className={className} data-test-id="ProdFac_ViewWrapper">
      {isLaptop ? (
        <Toolbar />
      ) : (
        location.pathname.match(new RegExp('/product/session/(offers).*')) && (
          <OffersToolbarContainerMobile />
        )
      )}
      {children}
      {isSocialLoginUrl && !showInfoModal && (
        <HelpButton onClick={() => dispatch(setShowInfoModal(true))}>
          {t('Help')}
        </HelpButton>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 100%;
  position: relative;

  ${mq.laptop} {
    flex-direction: row;
    background: #fdfcff;
  }
`;

const HelpButton = styled.button`
  position: fixed;
  top: 9.6rem;
  right: 1.6rem;
  cursor: pointer;
  background-color: ${({ theme }) => theme.brand.primary};
  color: white;
  font-weight: 500;
  border: none;
  border-radius: 50px;
  padding: 0.8rem 2.4rem;
  z-index: 10;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  transition: 0.2s;
  display: none;

  &:hover {
    background-color: ${({ theme }) => theme.brand.light};
  }

  ${mq.laptop} {
    display: flex;
    top: unset;
    bottom: 1.6rem;

    animation: ${goUp} 0.2s;
  }
`;

export default ViewWrapper;
